export enum RedirectRoutes {
  HTHOMELABEL = 'app/learn/rooms/aw-rooms',
  A8HOMELABEL = 'app/dashboard',
  ALLORGANIZATIONS = 'all-organizations',
  APPS = 'app/apps',
  APPSLABEL = 'Apps',
  APPS_STORE = 'app/apps/:tabName',

  INBOX = 'inbox',
  INBOX_LABEL = 'Inbox',

  HELP = 'help',
  HELPLABEL = 'Help',

  HELP_PAGE_DETAILS = 'help-page/:topic',
  HELP_DETAILS = 'help-page/help-doc/:id',
  HELP_DETAILSLABEL = 'Help Document',

  PROADVISOR = 'advisor',
  MYCONNECTIONS = 'advisor/connections',
  MYCONNECTIONS_LABEL = 'Network',

  CA_LANDING_URL = 'network/mynetwork',

  CART = 'cart',
  CARTLABEL = 'Cart',

  CHANGEPASSWORD = 'change-password',
  CHANGEPASSWORDLABEL = 'Change Password',
  NEED_HELP = 'Support',

  CONTACTUS = 'contactus',
  CONTACTUSLABEL = 'Contact Us',

  CONFIRMEMAIL = 'confirm-email',
  CONFIRMEMAILLABEL = 'Confirm Email',

  FORGOT_PASSWORD = 'forgot-password',
  FORGOT_PASSWORDLABEL = 'Forgot Password',

  ARTICLE_DETAILS = 'article-details',
  ARTICLE_DETAILS_LABEL = 'Article details',

  REGISTRATIONTYPE = 'registration',
  REGISTRATIONTYPELABEL = 'Registration',
  CHOOSEORG = 'choose-organization',
  CHOOSEORGLABEL = 'Choose Organization',
  SWITCH_COMPANY = 'Switch Company',
  SHAREROOM = 'room/share/:roomId',
  SHARETUTOR = 'ai-tutor/share/:botId',
  WEBINTEGRATOR = 'room/web-integrator/:roomId',
  TUTORWEBINTEGRATOR = 'ai-tutor/web-integrator/:botId',

  DATAUSAGE = 'data-usage',
  DATAUSAGELABEL = 'Data Usage',

  REFRESHORGS = 'refresh-businesses',
  REFRESHORGSLABEL = 'Refresh Businesses',

  HOMELABELNEW = 'Apps',

  DASHBOARD = 'app/dashboard',
  DASHBOARDLABEL = 'Dashboard',
  EC_VENDORS = 'vendors',
  EC_VENDORS_LABEL = 'vendors',

  // LOGIN = 'login/:email/:password',
  LOGIN = 'auth/login',
  LOGINLABEL = 'Login',

  SIGNUP = 'sign-up',
  SIGNUPLABEL = 'signup',

  REGISTRATION_TYPE = 'registration/:type',
  REGISTRATION_TYPE_EMAIL = 'registration/:type/:email',

  LOGIN_TEST = 'demo/:email/:password',
  LOGINTESTLABEL = 'Demo',

  REGISTRATION = 'invitation',
  REGISTRATIONLABEL = 'Registration',

  JCB_CREATION = 'jcb-creation',
  JCB_CREATIONLABEL = 'Registration',

  JCB_REGISTRATION = 'registration',
  JCB_REGISTRATIONLABEL = 'Registration',

  FIND_ACCOUNTANT_A8 = 'accountnat8-find-accountant',
  FIND_ACCOUNTANT_A8_LABEL = 'Find Accountant',

  MYSALESRECEIPTS = 'sales-receipts',
  MYSALESRECEIPTSLABEL = 'Sales Receipts',

  MYEXPENSES = 'expenses',
  MYSUBSCRIPTION = 'app-subscriptions',
  MYSUBSCRIPTIONLABEL = 'Subscriptions',

  SUBSCRIPTION = 'subscriptions/:tabsubName',
  SUBSCRIPTIONLABEL = 'Subscriptions',

  SUBSCRIPTION_TAB_CHANGE = 'app/learn/subscriptions',

  NOTFOUND = '**',
  NOTFOUNDLABEL = 'Page Not Found',

  ORGANIZATION = 'organization',
  ORGANIZATIONLABEL = 'Organization',

  ASSIGNSTAFF = 'assign-staff',
  ASSIGNSTAFFLABEL = 'Assign Staff',

  MENTOR = 'mentor',
  MENTOR_LABEL = 'Mentor',

  MENTEE = 'mentee',
  MENTEE_LABEL = 'Mentee',

  MYORGANIZATION = 'details',
  MYORGANIZATIONLABEL = 'Organization',


  MYORGANIZATIONA8 = 'app/myorganization',
  MYORGANIZATIONLABELA8 = 'Organization',

  INTEGRATIONS = 'app/integrations',
  INTEGRATIONSLABEL = 'Integrations',

  MYSUBSCRIPTIONS = 'app/app-subscriptions',
  MYSUBSCRIPTIONSLABEL = 'Subscriptions',

  TOP_RETAINER = 'retainer',
  TOP_RETAINER_LABEL = 'Retainer',

  TOP_TIMESHEETS = 'time-sheets',
  TOP_TIMESHEETS_LABEL = 'Timesheets',

  TOP_TIMER = 'time-cards/:tabName',
  TOP_TIMER_LABEL = 'Timer',

  TOP_TIMECARDS = '/appworkflow/time-cards',
  TOP_CRM_TIMECARDS = '/appcrm/time-cards',


  TOP_EXPENSES = 'expenses',
  TOP_EXPENSES_LABEL = 'Expenses',
  TOP_AC_PAYMENTS = 'ac-payments',
  TOP_AC_PAYMENTS_LABEL = 'Invoices',
  TOP_CB_PAYMENTS = 'cb-payments',
  TOP_CB_PAYMENTS_LABEL = 'Invoices',

  ORGANIZATIONBYID = 'organization/:id',
  NOORGANIZATIONBYID = 'no-organization',
  PAYMENTS = 'payments',
  PAYMENTSLABEL = 'Invoices',

  OM_Service_Bank = 'om-service-bank',
  OM_Service_Bank_LABEL = 'A8 Templates Bank',

  PROFILE = 'profile',
  PROFILELABEL = 'Profile',

  SUPPORT = 'support',
  SUPPORT_LABEL = 'Support',

  PRIVACY = 'privacy',
  PRIVACY_LABEL = 'privacy',

  QBCONNECT = 'qbconnect',
  QBCONNECTLABEL = 'HTConnect',

  GCONNECT = 'gconnect',
  GCONNECTLABEL = 'Google Connect',


  QBDISCONNECT = 'qbdisconnect',
  QBDISCONNECTLABEL = 'HTDisconnect',

  QBLAUNCH = 'qblaunch',
  QBLAUNCHLABEL = 'HTLaunch',

  FBCONNECT = 'fbconnect',
  FBCONNECTLABEL = 'FBConnect',

  FBDISCONNECT = 'fbdisconnect',
  FBDISCONNECTLABEL = 'FBDisconnect',

  FBLAUNCH = 'fblaunch',
  FBLAUNCHLABEL = 'FBLaunch',

  XEROLAUNCH = 'xerolaunch',
  XEROLAUNCHLABEL = 'XeroLaunch',

  XEROCONNECT = 'xeroconnect',
  XEROCONNECTLABEL = 'Xero Connect',

  SAGELAUNCH = 'sagelaunch',
  SAGELAUNCHLABEL = 'Sage Launch',

  SAGECONNECT = 'sageconnect',
  SAGECONNECTLABEL = 'Sage Connect',

  XERODISCONNECT = 'xerodisconnect',
  XERODISCONNECTLABEL = 'XeroDisconnect',

  REGISTER = 'register',
  REGISTERLABEL = 'register',

  PRO_WALLET_USAGE = 'usage',
  PRO_WALLET_USAGE_LABEL = 'Wallet Usage',

  RESETPASSWORD = 'resetpassword',
  RESETPASSWORDLABEL = 'Reset Password',

  STRIPECONNECT = 'stripe-connect',
  STRIPECONNECTLABEL = 'Stripe-Connect',

  SUBMITFORM = 'submit-form',
  SUBMITFORMLABEL = 'Submit Form',

  TEAM = 'app/staff',
  TEAMLABEL = 'Staff',

  A8_CERTIFICATION = 'app/a8-certification',
  A8_CERTIFICATION_LABEL = 'Certification',

  EARN_POINTS = 'earn-points',
  EARN_POINTSLABEL = 'Earn Points',

  PROADVISORS_CERTIFICATION = 'proadvisor-certification',
  PROADVISORS_CERTIFICATIONLABEL = 'Proadvisor Certification',

  TERMS = 'terms',
  UNAUTHORIZED = 'unauthorized',
  UNAUTHORIZEDLABEL = 'Unauthorized',

  RFQ_JOBS = 'rfq-jobs',
  RFQ_JOBS_LABEL = 'RFQ-Jobs',

  //Administration
  TEAM_Groups = 'app/staff-groups',
  TEAM_Groups_LABEL = 'Staff Groups',

  TEAM_RATES = 'staff-rates/:tabName',
  TEAM_RATES_LABEL = 'Staff Rates',

  TEAM_PROFILES = 'staff-profiles',
  TEAM_PROFILES_LABEL = 'Staff Profiles',

  TEAM_SCHEDULE = 'staff-schedule',
  TEAM_SCHEDULE_LABEL = 'Staff Schedule',

  SERVICES_ITEMS = 'service-items',
  SERVICES_ITEMS_LABEL = 'Service Items',

  CUSTOM_FIELDS = 'custom-fields',
  CUSTOM_FIELDS_LABEL = 'Custom Fields',

  CLIENT_PAYMENT_PROCESSES = 'client-payment-process',
  CLIENT_PAYMENT_PROCESSES_LABEL = 'Client Payment Process',

  APP_BOOK_SERVICE = 'book-service',
  APP_BOOK_SERVICE_LABEL = 'Book Service',

  APP_SETTINGS = 'app-settings',
  APP_SETTINGS_LABEL = 'App Settings',

  APP_NOTIFICATIONS = 'app-notifications',
  APP_NOTIFICATIONS_LABEL = 'App Notifications',

  CATEGORIES = 'classifications',
  CATEGORIES_LABEL = 'Setup',

  TEMPLATES = 'template',
  TEMPLATES_LABEL = 'Templates',
  // top nav
  ALLAPPSETTINGS = 'all-app-settings',
  ALLAPPSETTINGSLABEL = 'Settings',

  MYACCOUNTANT = 'organization-management/attributes',
  MYACCOUNTANTLABEL = 'Accountant',

  CLIENTS = 'clients',
  CLIENTS_LABEL = 'Clients',

  CLIENT_TAB = 'workflow/client/:clientId/:tabName',
  CLIENT_TAB_URL = 'client/:clientId/:tabName',

  CLIENT_PORAL_TAB = 'workflow/client/portal',
  CLIENT_PORAL_TAB_URL = 'client/portal/:clientId',

  CLIENT_CB_TAB = 'workflow/client-workspace',
  CLIENT_CB_TAB_URL = 'client-workspace/:clientId',

  CLIENT_PRO_TAB = 'proposal/client',
  CLIENT_PRO_TAB_URL = 'client/:clientId',

  ORGANIZE = 'organize',
  ORGANIZE_LABEL = 'Organize',

  WORKSPACE = 'my-accountant',
  WORKSPACE_LABEL = 'My Accountant',

  CLIENTS_config = 'client-management',
  CLIENTS_configLABEL = 'Client Management',

  SUPPORT_config = 'support-management',
  SUPPORT_configLABEL = 'Support Management',
  CLOUDBUSINESSUSERTYPE = 'CB',
  CLOUDACCOUNTANTUSERTYPE = 'CA',
  HONTRUUSERTYPE = 'HT',
  CUSTOMERPAYMENTS = 'customer-payments',
  CUSTOMERPAYMENTSLABEL = 'Invoices',
  MAIN_SETTINGS = 'app/categories',
  MAIN_SETTINGS_SETUP = 'app/setup',
  MAIN_SETTINGS_LABEL = 'Categories',
  PAYMENT_METHOD = 'app/payment-method',
  PAYMENT_METHOD_LABEL = 'Payment Method',

  ACTIVITY_FEED = 'activity-feed',
  ACTIVITY_FEED_LABEL = 'Activity Feed',

  CHAT = 'chat',
  CHATLABEL = 'Chat',

  TODO = 'to-do',
  TODOLABEL = 'To Do List',

  //Feature Module
  FEATURE = 'app',
  FEATURELABEL = 'app',



  NEWS = 'news',
  NEWS_LABEL = 'News',

  //Apps 
  AVAILABLE_APPS = 'available',
  AVAILABLE_APPS_LABEL = 'Available Apps',

  //Proposals
  SERVICE_REQUESTS = 'service-requests',
  SERVICE_REQUESTS_LABEL = 'Service Requests',

  PP_PROPOSALS_DEFAULT = 'proposals',
  PP_PROPOSALS_DEFAULT_LABEL = 'Proposals',

  PP_PROPOSALS = 'proposals/:tabName',
  PP_PROPOSALS_LABEL = 'Proposals',

  PP_PROPOSALS_RECEIVED = 'proposals-received',
  PP_PROPOSALS_RECEIVED_LABEL = 'Proposals Received',

  PP_PROPOSAL_DETAILS = 'proposal-details/:proposalId',
  PP_PROPOSAL_DETAILSLABEL = 'Proposal Details',

  PP_PRICING_TOOL = 'price-books',
  PP_PRICING_TOOL_LABEL = 'Price Books',

  PROPOSALS = 'proposal',
  PROPOSALS_LABEL = 'Proposal',

  OVERVIEW = 'overview',
  OVERVIEW_LABEL = 'Overview',

  PROPOSALS_SIMPLE = 'simple',
  PROPOSALS_SIMPLE_LABEL = 'Simple Proposals',

  PROPOSALS_ADVANCED = 'advanced',
  PROPOSALS_ADVANCED_LABEL = 'Advanced Proposals',

  PP_CLIENTS = 'clients',
  PP_CLIENTS_LABEL = 'Clients',

  PP_PACKAGES = 'packages',
  PP_PACKAGES_LABEL = 'Packages',

  PP_SERVICES = 'services',
  PP_SERVICES_LABEL = 'Services',

  PP_TERMS = 'terms',
  PP_TERMS_LABEL = 'Terms',

  PP_PROPOSAL_CLIENT_VIEW = 'proposal/client-view/:link/:email',
  PP_PROPOSAL_CLIENT_VIEW_LABEL = 'Proposal Client View',

  PP_SECTIONS = 'letters',
  PP_SECTIONSS_LABEL = 'Letters',

  PP_TEMPLATES = 'templates',
  PP_TEMPLATES_LABEL = 'Templates',

  PP_PROPOSAL_HISTORY = 'proposal-activities',
  PP_PROPOSAL_HISTORY_LABEL = 'Proposal Activities',

  NEW_PROPOSAL = 'new-proposal',
  EDIT_PROPOSAL = 'edit-proposal/:id',
  NEW_PROPOSAL_LABEL = 'Proposal',

  PP_PRICEBOOK_SETUP = 'price-books-setup',
  PP_PRICEBOOK_SETUP_LABEL = 'Price Book Setup',

  PB_CLIENTS = 'pricebook-clients',
  PB_CLIENTS_LABEL = 'Price Book Clients',

  PB_PRICEBOOK_PROPOSALS = 'pricebook-initiator',
  PB_PRICEBOOK_PROPOSALS_LABEL = 'Price Book Initiator',

  PP_WEB_INTEGRATOR = 'web-integrator',
  PP_WEB_INTEGRATOR_LABEL = 'web integrator',

  //Accountant
  ACCOUNTANT = 'workflow',
  ACCOUNTANT_LABEL = 'Workflow',

  AC_CLIENTS = 'clients',
  AC_CLIENTS_LABEL = 'Clients',

  AC_CLIENTS_LIST = 'clients-list',

  AC_CLIENTS_WORKSPACE = 'clients-workspace',

  AC_CLIENT_ORGANIZE = 'organize',
  AC_CLIENTS_ORGANIZE_LABEL = 'Organize',

  AC_CLIENT_PORTAL = 'clients-portal',
  AC_CLIENTS_PORTAL_LABEL = 'Clients Portal',

  AC_CLIENT_BILLING = 'billing-invoices',
  AC_CLIENTS_BILLING_LABEL = 'Billing Invoices',

  AC_BOOK_INVOICE = 'book-invoice',
  AC_BOOK_INVOICE_LABEL = 'Book Invoice',


  AC_CLIENT_GROUPS = 'groups',
  AC_CLIENT_GROUPS_LABEL = 'Client Groups',

  AC_CLIENTS_COMMUNICATION = 'inbox',
  AC_CLIENTS_COMMUNICATION_LABEL = 'Inbox',

  CALENDAR = 'calendar',
  CALENDAR_LABEL = 'Calendar',

  AC_JOBS = 'jobs',
  AC_JOBS_LABEL = 'Jobs',

  AC_TASKS = 'tasks',
  AC_TASKS_LABEL = 'Tasks',

  AC_JOB_TAB = 'app/workflow/job',
  AC_JOB_TAB_URL = 'job/:jobId/:tabName',

  AC_JOB_TASK = 'tasks',
  AC_JOB_TASK_LABEL = 'Tasks',

  AC_TEAM = 'staff',
  AC_TEAM_LABEL = 'Staff',

  AC_JOB_TASK_TAB = 'app/workflow/task',
  AC_JOB_TASK_TAB_URL = 'task/:taskId',

  AC_TIMESHEET = 'timesheets',
  AC_TIMESHEET_LABEL = 'Timesheets',

  AC_ALERTS = 'alerts',
  AC_ALERTS_LABEL = 'Alerts',

  AC_REPORTS = 'reports',
  AC_REPORTS_LABEL = 'Reports',

  AC_Staff = 'staff',
  AC_Staff_LABEL = 'staff',

  AC_Clients = 'clients',
  AC_Clients_LABEL = 'clients',

  AC_Billing = 'billing',
  AC_Billing_LABEL = 'billing',

  AC_REPORTS_PRODUCTIVITY = 'productivity',
  AC_REPORTS_BILLING_LABEL = 'Productivity',

  AC_REPORTS_CAPACITY_MANAGEMENT = 'capacity-management',
  AC_REPORTS_CAPACITY_MANAGEMENT_LABEL = 'Capacity management',

  AC_REPORTS_CLIENTTASKS = 'client-tasks',
  AC_REPORTS_CLIENTTASKS_LABEL = 'Client tasks',

  AC_REPORTS_TEAM_ACTIVITY = 'team-activity',
  AC_REPORTS_TEAM_ACTIVITY_LABEL = 'Team activity',

  AC_REPORTS_TIME = 'time-reports',
  AC_REPORTS_TIME_LABEL = 'Time reports',

  // AC_SETTINGS = 'settings',
  // AC_SETTINGS_LABEL = 'Settings',
  AC_CONTRACTS = 'agreements',
  AC_CONTRACTS_LABEL = 'Agreements',

  AC_CUSTOMER = 'customers',
  AC_CUSTOMER_LABEL = 'Customers',

  AC_GROUPS = 'groups',
  AC_GROUPS_LABEL = 'Groups',

  AC_EXPENSES = 'expenses',
  AC_EXPENSES_LABEL = 'Expenses',

  AC_CLIENT_SUBSCRIPTIONS = 'client-subscriptions',
  AC_CLIENT_SUBSCRIPTIONS_LABEL = 'Client subscriptions',

  AC_ISSUES = 'issues',
  AC_ISSUES_LABEL = 'Task issues',

  AC_RETAINER = 'retainer',
  AC_RETAINER_LABEL = 'Retainer',

  AC_BILLING = 'billing',
  AC_BILLING_LABEL = 'Billing',

  AC_PAYMENTS_INVOICE = 'app/workflow/billing/invoices',

  AC_PAYMENTS = 'invoices/:tabName',
  AC_PAYMENTS_LABEL = 'Invoices',

  AC_TEMPLATES = 'templates',
  AC_TEMPLATES_LABEL = 'Templates',

  AC_JOB_ACTIVITY_FEED = 'activity-feed',
  AC_JOB_ACTIVITY_FEED_LABEL = 'Activity Feed',

  AC_MILESTONE = 'milestones',
  AC_MILESTONE_LABEL = 'Milestones',

  AC_APPROVALS = ':tabName',
  AC_APPROVALS_LABEL = 'Task Approvals',

  AC_REVIEWS = 'job-reviews',
  AC_REVIEWS_LABEL = 'Job Reviews',

  AC_TASK_TIME_BUDGET = 'task-time-budget',
  AC_TASK_TIME_BUDGET_LABEL = 'Task Time Budget',

  AC_TASK_ACTIVITY_FEED = 'task-feed',
  AC_TASK_ACTIVITY_FEED_LABEL = 'Task Feed',

  AC_STAFF = 'staff',
  AC_STAFF_LABEL = 'Staff',

  AC_MASTERDATA = 'masterData',
  AC_MASTERDATA_LABEL = 'Master Data',

  AC_EMAIL_READ = 'email-read',
  AC_EMAIL_READ_LABEL = 'Email Read',

  AC_APPSETTINGS = 'setup',
  AC_APPSETTINGS_LABEL = 'Setup',

  AC_OVERVIEW = 'overview',
  AC_OVERVIEW_LABEL = 'Overview',

  AC_Service_Bank = 'ac-service-bank',
  AC_Service_Bank_LABEL = 'A8 Templates Bank',

  AC_TRASH_BIN = 'trashbin',
  AC_TRASH_BIN_LABEL = 'Trash Bin',

  AC_Templates_Library = 'templates-library',
  AC_Templates_Library_LABEL = 'Templates Bank',

  AC_PERSONAL_PROFILE = 'personal-profile',
  AC_PERSONAL_PROFILELABEL = 'Personal Profile',

  AC_ORGPROFILE = 'org-profile',
  AC_ORGPROFILELABEL = 'Org Profile',

  AC_PBCLISTS = 'client-request',
  AC_PBCLISTS_LABEL = 'Client Request',

  AC_TIME_BUDGET = 'time-budget',
  AC_TIME_BUDGET_LABEL = 'Time Budget',

  AC_BUDGET = 'job-budget',
  AC_BUDGET_LABEL = 'Job Budget',

  AC_SERVICES = 'services',
  AC_SERVICES_LABEL = 'Services',

  AC_ORGUSERPROFILE = 'user-profiles-list',
  AC_ORGUSERPROFILELABEL = 'User Profile List',

  AC_READISSUE = 'workflow/readissue/:issue_Id',
  AC_READISSUELABEL = 'Issue Link',


  //client portal
  CLIENT_PORTAL_LINK = 'client-portal/:bfemId?auth=:authcode',
  CLIENT_PORTAL_LINK_LABEL = 'Proposal Client View',

  EMPLOYEE_PORTAL_LINK = 'employee-portal/:employeeId/:authCode/dashboard',
  EMPLOYEE_PORTAL_LINK_LABEL = 'Employee Portal',

  EMPLOYEE_USER_PORTAL_LINK = 'employee-portal/:employeeId/:userId/:authCode/dashboard',

  CLIENT_PORTAL_JOB_LINK = 'client-portal/job/:jobId/:clientId/:authCode',

  CLIENT_CA_PORTAL_JOB_LINK = 'client-portal/job/:jobId/:clientId/:userId/:authCode',

  CLIENT_PORTAL_JOB_ID_LINK = 'client-portal/job',

  CLIENT_PORTAL_JOB_MAIN_LINK = 'client-portal/:clientId/:authCode/:tabname',

  CLIENT_CA_PORTAL_JOB_MAIN_LINK = 'client-portal/:clientId/:userId/:authCode/:tabname',


  CLIENT_PORTAL_CHANGE_TAB_LINK = 'client-portal',

  CLIENT_PORTAL_VIEW_PROPOSAL_TAB_LINK = 'proposal/client-view',

  //projects
  PROJECTS = 'workflow',
  PROJECTS_LABEL = 'Workflow',

  PM_JOBS = 'jobs',
  PM_JOBS_LABEL = 'Jobs',

  PM_CLIENTS = 'clients',
  PM_CLIENTS_LABEL = 'Clients',

  PM_CLIENT_ORGANIZE = 'organize',
  PM_CLIENTS_ORGANIZE_LABEL = 'Organize',

  PM_CLIENTS_COMMUNICATION = 'communication',
  PM_CLIENTS_COMMUNICATION_LABEL = 'Communication',


  PM_JOB_TASK = 'jobtasks',
  PM_JOB_TASK_LABEL = 'Tasks',

  PM_TIMESHEET = 'timesheets',
  PM_TIMESHEET_LABEL = 'Timesheets',

  PM_CLIENT_SUBSCRIPTIONS = 'client-subscriptions',
  PM_CLIENT_SUBSCRIPTIONS_LABEL = 'Client subscriptions',

  PM_ALERTS = 'alerts',
  PM_ALERTS_LABEL = 'Alerts',

  PM_REPORTS = 'reports',
  PM_REPORTS_LABEL = 'Reports',

  PM_CONTRACTS = 'agreements',
  PM_CONTRACTS_LABEL = 'Agreements',

  PM_CUSTOMER = 'customers',
  PM_CUSTOMER_LABEL = 'Customers',

  PM_GROUPS = 'groups',
  PM_GROUPS_LABEL = 'Groups',

  PM_EXPENSES = 'expenses',
  PM_EXPENSES_LABEL = 'Expenses',

  PM_SUBSCRIPTIONS = 'subscriptions',
  PM_SUBSCRIPTIONS_LABEL = 'Subscriptions',

  PM_ISSUES = 'issues',
  PM_ISSUES_LABEL = 'Task issues',

  PM_RETAINER = 'retainer',
  PM_RETAINER_LABEL = 'Retainer',

  PM_PAYMENTS = 'payments',
  PM_PAYMENTS_LABEL = 'Invoices',

  PM_TEMPLATES = 'templates',
  PM_TEMPLATES_LABEL = 'Templates',

  PM_MILESTONE = 'milestones',
  PM_MILESTONE_LABEL = 'Milestones',

  PM_APPROVALS = 'approvals',
  PM_APPROVALS_LABEL = 'Task Approvals',

  PM_STAFF = 'staff',
  PM_STAFF_LABEL = 'Staff',

  PM_MENTOR = 'mentors',
  PM_MENTOR_LABEL = 'Mentors',

  PM_MENTOR_LIST = 'mentors-list',
  PM_MENTOR_LIST_LABEL = 'Mentors',

  PM_MENTOR_GROUPS = 'mentor-groups',
  PM_MENTOR_GROUPS_LABEL = 'Mentors',

  PM_MENTEE = 'mentees',
  PM_MENTEE_LABEL = 'Mentees',

  PM_MENTEE_LIST = 'mentees-list',
  PM_MENTEE_LIST_LABEL = 'Mentees',

  PM_MENTEE_GROUPS = 'mentee-groups',
  PM_MENTEE_GROUPS_LABEL = 'Mentees',

  PM_MASTERDATA = 'masterData',
  PM_MASTERDATA_LABEL = 'Master Data',

  PM_EMAIL_READ = 'email-read',
  PM_EMAIL_READ_LABEL = 'Email Read',

  PM_APPSETTINGS = 'setup',
  PM_APPSETTINGS_LABEL = 'Setup',

  PM_PBCLISTS = 'client-request',
  PM_PBCLISTS_LABEL = 'Client Request',

  PM_READISSUE = 'workflow/readissue/:issue_Id',
  PM_READISSUELABEL = 'Issue Link',

  PP_PRICE_BOOK_VIEW = 'price-book-view/:id',
  PP_PRICE_BOOK_VIEW_LABEL = 'Price Book',

  //LMS AI PORTAL
  LMS_AI_PORTAL = 'learn',
  LMS_AI_PLAY = 'public',
  LMS_AI_CHATGPT = 'chatgpt',
  LMS_AI_PRODUCTIVE = 'ai-tools',
  LMS_AI_PRIVATE = 'private',
  LMS_AI_TUTOR_GROUPS = 'ai-tutor-groups',
  LMS_AI_PUBLIC_TUTOR_GROUPS = 'ai-public-tutor-groups',
  LMS_AI__TUTOR_KNOWLEDGE_FILES = 'ai-tutors-knowledge-files',
  LMS_AI_BOT = 'manage-ai-tutor',
  LMS_CREATE_AI_BOT_GROUPS = 'create-tutor-groups',
  LMS_AI_MANAGE_BOT = 'manage-ai-tutor/:botId',
  LMS_AI_MENTORS_DIRECTORY = 'mentors-directory',
  LMS_AI_CONNECTIONS = 'connections',
  LMS_AI_MY_PROFILE = 'my-profile',
  LMS_AI_MY_FOLLOWERS = 'my-followers',
  LMS_AI_FAVORITIES = 'favorites',
  LMS_AI_LIVE_STREAMS = 'live-streams',
  LMS_ROOM_INVITATIONS = 'room-invitations',
  LMS_AI_FEED_AI = 'feed-ai',
  LMS_AI_MY_ACTIVITY = 'my-activity',
  LMS_AI_GUIDELINE = 'guideline',
  LMS_AI_FILE = 'file',
  LMS_AI_SERVICE = 'service',
  LMS_AI_NOTES = 'notes',
  LMS_CREATE_ROOM = 'manage-room',
  LMS_AI_UPDATE_BOT = 'update-ai-tutor/:botId',
  LMS_AI_UPDATE_ROOM = 'update-room/:roomId',
  LMS_AI_BOT_LAUNCH = 'ai-tutors/launch/:botId/:tabName',
  LMS_AI_BOT_GROUP_LAUNCH = 'ai-tutors-group/launch/:botgroupId',
  LMS_AI_LIVESTREAM = 'livestream',
  LMS_AI_PORTAL_FEED = 'feed',
  LMS_AI_PORTAL_ROOMS = 'rooms',
  LMS_AI_PORTAL_ROOMSLIST = 'private-rooms',
  LMS_AI_PORTAL_TEMPLATES = 'ai-tools',
  LMS_AI_PORTAL_TEMPLATES_LIST = 'list',
  LMS_AI_PORTAL_PRIVATE_TEMPLATES = 'private-templates',
  LMS_AI_PORTAL_PUBLIC_TEMPLATES = 'public-templates',
  LMS_AI_PORTAL_ORGANIZATION_TEMPLATES = 'organization-templates',
  LMS_ROOMS_RECEIVED = 'received',
  LMS_ROOMS_SENT = 'sent',
  LMS_AI_PORTAL_ROOMSLISTPUBLIC = 'public-rooms',
  LMS_COMMUNITY_ROOMS = 'aw-rooms',
  LMS_AI_PORTAL_REQUESTROOMS = 'request-rooms/:tabName',
  LMS_AI_PORTAL_ROOMSINNER = 'room-launch/:roomId/:tabName',
  LMS_AI_PORTAL_ROOMSINNER_NEWROOMPOST = 'room-launch/:roomId/:tabName/post/:isnewpost',
  LMS_AI_PORTAL_ROOMSINNER_POST = 'room-launch/:roomId/:tabName/post/:crH_Id',
  LMS_AI_PORTAL_ROOMSINNER_LIVE = 'room-launch/:roomId/:tabName/:aiutL_Id',
  LMS_AI_PORTAL_ROOMSINNER_FORMS = 'room-launch/:roomId/:tabName/:form_Id',
  LMS_AI_ROOM_MEMBERS_CHAT = 'room-launch/:roomId/:tabName/members-chat',
  LMS_AI_ROOM_MEMBERS = 'room-launch/:roomId/members',
  LMS_EXPLORE = 'explore',
  LMS_AI_WALLET = 'wallet',
  LMS_AI_WALLETTYPE = 'wallet/:type',
  LMS_AI_USAGE = 'usage',
  LMS_AI_SUBSCRIPTIONS = 'subscriptions',
  LMS_AI_PAYMENTS = 'payments',
  LMS_AI_INCOME = 'income',
  LMS_AI_IN_WALLET = 'ind-wallet',
  LMS_AI_CHECKOUT = 'check-out',
  LMS_AI_PORTAL_CLIENTS = 'clients',
  LMS_AI_PORTAL_NETWORK = 'network',
  LMS_AI_TUTORS = 'ai-tutors',
  LMS_AI_PORTAL_CREATE = 'create',
  LMS_AI_PORTAL_COMMUNITY = 'community',
  LMS_AI_PORTAL_WALLET = 'wallet',
  LMS_AI_PORTAL_SUPPORT = 'support',
  LMS_AI_PORTAL_FEED_AI_FILES = 'feed-ai-files',
  LMS_AI_PORTAL_NOTIFICATIONS = 'notifications',
  LMS_AI_HT_SETUP = 'ht-setup',
  LMS_AI_SETUP = 'setup',
  LMS_AI_PORTAL_READ_ARTCLE = 'readarticle',
  LMS_AI_PORTAL_MY_GOALS = 'profile',
  LMS_AI_Community_Service = 'community-service',
  LMS_AI_Stripe_Success = 'stripe-payment-success',
  LMS_AI_Stripe_Cancel = 'stripe-payment-cancel',
  LMS_PRODUCTS = 'services',
  LMS_SERVICES = 'stripe-services',
  LMS_SERVICES_INDIA = 'services',
  LMS_PAID_SERVICES = 'paid-services',
  LMS_PACKAGES = 'packages',
  LMS_FAVOURITES = 'favorites',
  LMS_FAVOURITES_Notes = 'notes',
  LMS_FAVOURITES_Rooms = 'rooms',
  LMS_FAVOURITES_Tools = 'ai-tools',
  LMS_FAVOURITES_Tool_TEMPLATES = 'ai-tool/templates',
  LMS_FAVOURITES_Tutors = 'tutors',
  LMS_FAVOURITES_Tutor_GROUPS = 'tutor-groups',
  LMS_FAVOURITES_Review = 'my-reviews',
  LMS_INSIGHTS = 'insights',
  LMS_ACTIVITY = 'activity',
  LMS_ACTIONS = 'actions',
  LMS_USAGE = 'usage',
  LMS_TUTOR_MESSAGES = 'tutor-messages/:botId/:roomId',
  LMS_History = 'history',
  LMS_PRICING = 'pricing',
  LMS_CERTIFICATION = 'certification',
  PAID_SERVICES = 'paid-services',
  ASK_MEG = 'ask-meg',


  //Air ticketing
  AIRTICKETING = 'airticketing',

  //Business Directory
  BUSINESS = 'businessdirectory',
  BUSINESS_LABEL = 'Business Directory',

  BD_ENTITY_SEARCH = 'entity-search',
  BD_ENTITY_SEARCH_LABEL = 'Entity Search',

  BD_NAICS = 'naics',
  BD_NAICS_LABEL = 'NAICS Search',

  BD_MY_FAVORITES = 'myfavorites',
  BD_MY_FAVORITES_LABEL = 'Favorites',

  BD_SETTINGS = 'appsettings',
  BD_SETTINGS_LABEL = 'Settings',

  //Crm
  CRM = 'crm',
  CRM_LABEL = 'CRM',
  CRM_READISSUE = 'crm/readissue/:issue_Id',
  CRM_READISSUELABEL = 'Issue Link',

  CRM_CLIENTS = 'clients',
  CRM_CLIENTS_LABEL = 'Clients',

  CRM_OVERVIEW = 'overview',
  CRM_OVERVIEW_LABEL = 'Overview',

  CRM_CLIENT_TAB = 'crm/client',
  CRM_CLIENT_TAB_URL = 'client/:clientId',

  CRM_JOB_TAB = 'crm/activity',
  CRM_JOB_TAB_URL = 'activity/:jobId/:tabName',

  CRM_ISSUES = 'issues',
  CRM_ISSUES_LABEL = 'Client Issues',

  CRM_ACTIVITIES = 'activities',
  CRM_ACTIVITIES_LABEL = 'Activities',

  CRM_TEMPLATES = 'templates',
  CRM_TEMPLATES_LABEL = 'Templates',

  CRM_QBO = 'qbo',

  CRM_SALESFLOW = 'salesflow',

  CRM_QBO_ESTIMATES = 'estimates',

  CRM_QBO_TIMECARD_INTERFACE = 'timecardinterface',

  CRM_QBO_SALESORDER = 'salesorders',

  CRM_ACTIVITY_TEMPLATES = 'activity-templates',
  CRM_ACTIVITY_TEMPLATES_LABEL = 'Activity Templates',

  CRM_A8_ACTIVITY_TEMPLATES = 'activity-templates-bank',
  CRM_A8_ACTIVITY_TEMPLATES_LABEL = 'A8 Activity Templates',

  CRM_TASK = 'tasks',
  CRM_TASK_LABEL = 'Tasks',

  CRM_ACTIVITYFEED = 'task-feed',
  CRM_ACTIVITYFEED_LABEL = 'Task Feed',

  CRM_APPROVALS = 'task-approvals',
  CRM_APPROVALS_LABEL = 'Tasks Approvals',

  CRM_SETUP = 'setup',
  CRM_SETUP_LABEL = 'Setup',

  CRM_SALES_PIPE_LINE = 'sales-pipeline',

  CRM_LEAD_SOURCE = 'lead-source',

  CRM_Service_Bank = 'crm-service-bank',
  CRM_Service_Bank_LABEL = 'A8 Templates Bank',

  CRM_TRASH_BIN = 'trashbin',
  CRM_TRASH_BIN_LABEL = 'Trash Bin',

  CRM_SERVICES = 'services',
  CRM_SERVICES_LABEL = 'Services',

  CRM_OPPORTUNITIES = 'opportunities',

  CRM_REPORTS = 'reports',
  CRM_REPORTS_LABEL = 'Reports',

  CRM_REPORTS_PRODUCTIVITY = 'productivity',
  CRM_REPORTS_BILLING_LABEL = 'Productivity',

  CRM_REPORTS_CAPACITY_MANAGEMENT = 'capacity-management',
  CRM_REPORTS_CAPACITY_MANAGEMENT_LABEL = 'Capacity management',

  CRM_REPORTS_CLIENTTASKS = 'client-tasks',
  CRM_REPORTS_CLIENTTASKS_LABEL = 'Client tasks',

  CRM_REPORTS_TEAM_ACTIVITY = 'team-activity',
  CRM_REPORTS_TEAM_ACTIVITY_LABEL = 'Team activity',

  CRM_REPORTS_TIME = 'time-reports',
  CRM_REPORTS_TIME_LABEL = 'Time reports',

  //Documents
  DOCUMENTS = 'documents',

  //Dynamic Forms
  DYNAMICFORMS = 'dynamicforms',
  DYNAMICFORMS_LABEL = 'Dynamic forms',

  DF_ALLFORMS = 'allforms',
  DF_ALLFORMS_LABEL = 'All Forms',

  DF_APPSETTINGS = 'appsettings',
  DF_APPSETTINGS_LABEL = 'App settings',

  DF_MYFORMS = 'myforms',
  DF_MYFORMS_LABEL = 'Forms',

  DF_POSTFORM = 'postform',
  DF_POSTFORMID = 'postform/:id',
  DF_POSTFORM_LABEL = 'Create form',

  DF_PREVIEWFORM = 'previewform',
  DF_PREVIEWFORM_LABEL = 'Preview form',

  DF_PUBLICTEMPLATE = 'public-templates',
  DF_PUBLICTEMPLATE_LABEL = 'Public templates',

  DF_QUESTIONBANK = 'questionbank',
  DF_QUESTIONBANK_LABEL = 'Question bank',

  DF_SENDFORM = 'sendforms',
  DF_SENDFORM_LABEL = 'Send form',

  //Email Read
  EMAILREAD = 'email-read',
  EMAILREAD_LABEL = 'Email Read',

  ER_MAIL_BOX = 'mail-box',
  ER_MAIL_BOX_LABEL = 'Mail Box',

  ER_MY_MAILS = 'mymails',
  ER_MY_MAILS_LABEL = 'Mails',

  ER_TRANSACTIONS = 'transactions',
  ER_TRANSACTIONS_LABEL = 'Transactions',

  ER_CUSTOMERS = 'customers',
  ER_CUSTOMERS_LABEL = 'Customers',

  ER_SETTINGS = 'appsettings',
  ER_SETTINGS_LABEL = 'Settings',

  //Email Campaign
  EMAILCAMPAIGN = 'email-campaign',
  EMAILCAMPAIGNLABEL = 'Campaigns',

  EMAILCAMPAIGN_SIMPLE = 'campaigns',
  EMAILCAMPAIGN_SIMPLE_LABEL = 'Campaigns',

  EMAILCAMPAIGN_ADVANCED = 'advanced-campaigns',
  EMAILCAMPAIGN_ADVANCED_LABEL = 'Advanced Campaigns',

  EMAILCAMPAIGN_ADHOC = 'adhoc-campaigns',
  EMAILCAMPAIGN_ADHOC_LABEL = 'Adhoc Campaigns',

  EMAILCAMPAIGN_HT_ADHOC = 'ht-adhoc-campaigns',
  EMAILCAMPAIGN_HT_ADHOC_LABEL = 'HT Adhoc Campaigns',

  EMAILCAMPAIGN_EVENTS = 'eventbased-campaigns',
  EMAILCAMPAIGN_EVENTS_LABEL = 'Event Based Campaigns',

  EMAILCAMPAIGN_ROLLING = 'rollingwave-campaigns',
  EMAILCAMPAIGN_ROLLING_LABEL = 'Rolling wave Campaigns',

  EC_AUTOMATION = 'orchestration',
  EC_AUTOMATIONLABEL = 'Orchestration',

  NEW_CAMAPIGN = 'email-campaign/new-campaign/:campaigntype',
  EDIT_CAMPAIGN = 'email-campaign/edit-campaign/:id',
  NEW_CAMPAIGN_LABEL = 'Campaign',

  NEW_CAMAPIGN_TAB = 'new-campaign',
  EDIT_CAMPAIGN_TAB = 'edit-campaign/:id',

  NEW_EVENT_CAMAPIGN = 'email-campaign/advanced-campaigns/new-event-campaign',
  NEW_EVENT_CAMAPIGN_TAB = 'new-event-campaign',
  EDIT_EVENT_CAMPAIGN_TAB = 'advanced-campaigns/edit-event-campaign/:id',

  EC_TEMPLATES = 'templates',
  EC_TEMPALTESLABEL = 'Templates',

  EC_MASTERDATA = 'masterdata',
  EC_MASTERDATALABEL = 'Master Data',

  EC_OVERVIEW = 'overview',
  EC_OVERVIEWLABEL = 'Overview',

  EC_APPSETTINGS = 'setup',
  EC_APPSETTINGSLABEL = 'Setup',

  EC_CLIENTS = 'clients',
  EC_CLIENTS_LABEL = 'Clients',

  EC_EMAILBANK = 'groups',
  EC_EMAIBANK_LABEL = 'Groups',

  EC_EVENTS = 'events',
  EC_EVENTS_LABEL = 'Events',

  EC_CONTACTS = 'contacts',
  EC_CONTACTS_LABEL = 'Contacts',

  EC_TEMPLATES_BANK = 'templates-bank',
  EC_TEMPLATES_BANK_LABEL = 'Email Templates Bank',

  EC_EMAIL_UNSUBSCRIBE = 'campaigns/email-unsubscribe/:eCGM_Id',
  EC_EMAIL_UNSUBSCRIBE_LABEL = 'Campaign Emails Unsubscribe',



  //PRO-CHATGPT
  PRO_CHATGPT = 'prochatgpt',
  PRO_CHATGPT_LABEL = 'prochatgpt',

  PRO_STACKHOLDER = 'stackholder',
  PRO_STACKHOLDER_LABEL = 'Stackholder',

  PRO_CHATBOT = 'chatbot',
  PRO_CHATBOT_LABEL = 'Chatbot',

  PRO_GPT = 'progpt',
  PRO_GPT_LABEL = 'ProGPT',

  PRO_CLIENT_PORTAL = 'clientportal',
  PRO_CLIENT_PORTAL_LABEL = 'clientportal',

  PRO_CREATE_CHATBOT = 'createchatbot',
  PRO_CREATE_CHATBOT_LABEL = 'createchatbot',

  PRO_EDIT_CHATBOT = 'proai/chatbot/edit/:id',

  PRO_EDIT_CHATBOT_LABEL = 'editchatbot',

  PRO_WALLET = 'wallet',
  PRO_WALLET_LABEL = 'Wallet',

  PRO_CHATBOT_LIST = 'chatbotlist',
  PRO_CHATBOT_LIST_LABEL = 'Chatbotlist',

  PRO_EMPLOYEE_PORTAL = 'employeeportal',
  PRO_EMPLOYEE_PORTAL_LABEL = 'Employeeportal',

  PRO_EMPLOYEE = 'employee',
  PRO_EMPLOYEE_LABEL = 'Employee',


  PRO_COMPLETIONS = 'completions',
  PRO_COMPLETIONS_LABEL = 'Completions',

  PLAYGROUND_AI = 'ai-playground',
  PLAYGROUND_AI_LABEL = 'ai-playground',

  PCG_AI_OVERVIEW = 'overview',
  PCG_AI_OVERVIEW_LABEL = 'overview',

  PCG_AI_CLIENTS = 'clients',
  PCG_AI_CLIENTS_LABEL = 'Clients',

  PCG_AI_PROCHATGPT = 'prochatgpt',
  PCG_AI_PROCHATGPT_LABEL = 'prochatgpt',

  PCG_AI_CLIENT_PORTAL = 'client-portal',
  PCG_AI_CLIENT_PORTAL_LABEL = 'client-portal',

  PCG_AI_CLIENT = 'clients',
  PCG_AI_CLIENT_PORTAL_LINK = 'clients/client-portal/:clientId',
  PCG_AI_CLIENT_LABEL = 'clients',

  PRO_AI_CONTENT = 'content',
  PRO_AI_CONTENT_LABEL = 'Content',

  PRO_AI_EDIT_CONTENT = 'editcontent',
  PRO_AI_EDIT_CONTENT_LABEL = 'Edit-Content',

  PRO_AI_FILES = 'files',
  PRO_AI_FILES_LABEL = 'Files',

  PCG_AI_EMPLOYEE_PORTAL = 'employee-portal',
  PCG_AI_EMPLOYEE_PORTAL_LABEL = 'employee-portal',

  PCG_AI_EMPLOYEE = 'employee',
  PCG_AI_EMPLOYEE_LABEL = 'employee',

  PCG_AI_CREATE_CHATBOT = 'create-chatbot',
  PCG_AI_CREATE_CHATBOT_LABEL = 'create-chatbot',

  PCG_OWN_DATA_ANALYSIS = 'own-data-analysis',
  PCG_OWN_DATA_ANALYSIS_LABEL = 'own-data-analysis',

  PCG_AI_TOKENS = 'tokens',
  PCG_AI_TOKENS_LABEL = 'tokens',

  PCG_AI_CHATBOT_LIST = 'chatbotlist',
  PCG_AI_CHATBOT_LIST_LABEL = 'chatbotlist',

  PCG_AI_CHATBOT = 'ai-chatbot',
  PCG_AI_CHATBOT_LABEL = 'ai-chatbot',

  PCG_QUICKBOOKS_DATA = 'quickbooks-data',
  PCG_QUICKBOOKS_DATA_LABEL = 'quickbooks-data',

  PCG_SERVICE_ITEMS = 'service-items',
  PCG_SERVICE_ITEMS_LABEL = 'service-items',

  PCG_CHATBOTS = 'chatbot',
  PCG_CHATBOTS_LABEL = 'chatbot',



  // Staff performance
  STAFF_PERFORMANCE = 'staff-performance',
  STAFF_PERFORMANCE_LABEL = 'Staff Performance',


  //Framework
  FRAMEWORK = 'framework',
  FRAMEWORKLABEL = 'Framework',
  FW_APPSERVICES = 'app-services',
  FW_APPSERVICESLABEl = 'App Services',
  FW_STAKEHOLDERS = 'stakeholders',
  FW_STAKEHOLDERS_LABEL = 'Stakeholders',
  FW_CATEGORY = 'categories',
  CHAT_GUIDELINES = 'ai-chat-guidelines',
  AI_PLAY_GUIDELINES = 'ai-play-guidelines',
  FW_PRO_AI = 'pro-ai',
  FW_AI_PLAY = 'ai-play',
  FW_PROCHAT_GPT = 'prochatgpt',
  FW_CONTENT = 'content',
  FW_PRICING = 'pricing',
  FW_QBO_APIS = 'books-apis',
  AZURE_PROMPT = 'azure-prompt',
  FW_CATEGORYLABEl = 'Categories',
  FW_STRIPE_CUSTOMERS = 'stripe-customers',
  FW_ACTIVITY_FEED_LABEL = 'Activity feed',
  FW_ACTIVITY_FEED = 'activity-feed',
  FW_STRIPE_CUSTOMERSLABEL = 'Stripe Customers',
  FW_DBTABLES = 'dbtables',
  FW_HELP_DOCS = 'helpdocs',
  FW_LICENSES_INFO = 'licenses-info',
  FW_DBTABLESLABEl = 'Db Tables',
  FW_HELP_DOCS_LABEL = 'Videos Input',
  FW_LICENSES_INFOLABEL = 'Licenses Info',
  FW_USAGEMASTER = 'usage-master',
  FW_USAGEMASTERLABEl = 'Usage Master',
  FW_SETUP_APPSETTINGS = 'all-app-settings',
  FW_ALL_ORGANIZATIONS = 'all-organizations',
  FW_ALL_ORGANIZATIONSLABEL = 'All Organizations',
  FW_SERVICE_BANK = 'servicebank',
  FW_SERVICE_BANKLABEL = ' A8 Template Bank',
  // FW_CONTACT = 'contact',
  // FW_CONTACTLABEL = 'Contact',
  FW_FEEDBACK = 'feedbacks',
  FW_FEEDBACKLABEL = 'Feedbacks',
  FW_HELP = 'help',
  FW_HELPLABEL = 'Help',
  FW_INVEST_IN_US = 'invest-in-us',
  FW_INVEST_IN_USLABEL = 'Invest in Us',
  FW_NOTIFICATIONS = 'notifications',
  FW_NOTIFICATIONSLABEL = 'Notifications',
  FW_MASTERDATA = 'masterdata',
  FW_MASTERDATALABEL = 'Master Data',
  FW_PROADVISORREGISTER = 'proadvisor-registration/:type/:id',
  FW_PROADVISORDATAENTRY = 'proadvisor-dataentry-yperaxiaitsolutions-chandu-access',
  FW_PROADVISORREGISTERLABEL = 'ProAdvisor Registration',
  FW_PROADVISORDATAENTRYLABEL = 'ProAdvisor Data Entry',
  HTML_TEMPLATESLABEL = 'HTML TEMPLATES',
  HTML_TEMPLATES = 'html-templates',
  APPSETTINGSLABEL = 'App Settings',
  APPSETTINGS = 'app-settings',

  //Fraud Detection
  FRAUDDETECTION = 'frauddetection',

  //Jobs
  JS_JOBS = 'jobs',
  JS_JOBSLABEL = 'Jobs',

  JS_FINDJOBS = 'find-jobs',
  JS_FINDJOBSLABEL = 'Find Jobs',

  JS_FINDACCOUNTANT = 'find-accountant',
  JS_FINDACCOUNTANTLABEL = 'Find accountant',

  JS_FINDAC = 'find-accountant-seemore',
  JS_FINDACLABEL = 'Find accountant',

  JS_MYJOBSDRAFT = 'my-jobs-draft',
  JS_MYJOBSDRAFTLABEL = 'Drafts',

  JS_MYJOBSPOSTED = 'my-jobs',
  JS_MYJOBSPOSTEDLABEL = 'Posted',

  JS_MYCLOSEDJOBS = 'my-jobs-closed',
  JS_MYCLOSEDJOBSLABEL = 'Closed',

  JS_MYJOBSTATUS = 'service-requests/my-jobs-status',
  JS_MYJOBSTATUSLABEL = 'Status',

  JS_MATCHEDJOBS = 'my-jobs-matched',
  JS_MATCHEDJOBSLABEL = 'Matched',

  JS_INPROCSESSJOBS = 'my-jobs-proposed',
  JS_INPROCSESSJOBSLABEL = 'Inprocess',

  JS_SHORTLISTEDJOBS = 'my-jobs-shortlisted',
  JS_SHORTLISTEDJOBSlabel = 'Shortlisted',

  JS_PROPOSALAJOB = 'service-requests/details',
  JS_PROPOSALAJOBLABEL = 'Details',

  JS_SELECTEDJOBS = 'my-jobs-seleted',
  JS_SELECTEDJOBSLABEL = 'Seleted',

  JS_REJECTEDJOBS = 'my-jobs-closed-ca',
  JS_REJECTEDJOBSLABEL = 'Closed',

  JS_PROPOSALSSTATUS = 'service-requests/status-proposals',
  JS_PROPOSALSSTATUSLABEL = 'Proposals status',

  JS_MATCHEDPROPOSALS = 'proposals-matched',
  JS_MATCHEDPROPOSALSLABEL = 'Matched',

  JS_INPROCESSPROPOSALS = 'proposals',
  JS_INPROCESSPROPOSALSLABEL = 'Proposed',

  JS_SHORTLISTEDPROPOSALS = 'proposals-shortlisted',
  JS_SHORTLISTEDPROPOSALSLABEL = 'Shortlisted',

  JS_SELECTEDPROPOSALS = 'proposals-selected',
  JS_SELECTEDPROPOSALSLABEL = 'Selected',

  JS_REJECTEDPROPOSALS = 'proposals-closed',
  JS_REJECTEDPROPOSALSLABEL = 'Closed',

  JS_JOBPOST = 'service-requests/post-service-request',
  JS_JOBPOSTLABEL = 'Request Service',

  JS_PERSONALPROPROFILE = 'personal-profile',
  JS_PERSONALPROPROFILELABEL = 'Personal profile',

  JS_ORGPROFILE = 'org-profile',
  JS_ORGPROFILELABEL = 'Org profile',

  JS_ORGUSERPROFILE = 'org-user-profiles',
  JS_ORGUSERPROFILELABEL = 'Org user profiles',

  JS_SAVEDJOBS = 'js-saved-job',
  JS_SAVEDJOBSLABEL = 'Saved jobs',

  JS_SAVEDACCOUNTANT = 'js-accountant-job',
  JS_SAVEDACCOUNTANTLABEL = 'Saved accountants',

  JS_INVITECB = 'invite-cb',
  JS_INVITECBLABEL = 'Invited',

  JS_INVITECA = 'invite-ca',
  JS_INVITECAlabel = 'Invited',

  JS_JOBSPAYMENT = 'payments',
  JS_JOBSPAYMENTLABEL = 'Invoices',


  JS_JOBLINK = 'getjob/:job_Id',
  JS_JOBLINKLABEL = 'Job Link',





  //Knowledge Share
  KNOWLEDGESHARE = 'knowledgeshare',
  KSSHARE = 'knowledgeshare/readarticle/:id',

  KSSHAREARTICLE = 'sharearticle/:id',
  KSSHARELABEL = 'Share Article',
  //Mobileweb
  MOBILEWEB = 'mobileweb',
  MOBILEWEBLABEL = 'mobileweb',

  MW_CREATEAPP = 'createapp',
  MW_CREATEAPPLABEL = 'createapp',

  MW_MYAPPS = 'myapps',
  MW_MYAPPSLABEL = 'myapps',

  MW_DEVELOPERS = 'mw-developers',
  MW_DEVELOPERSLABEL = 'mw-developers',

  MW_ALLAPPS = 'allapps',
  MW_ALLAPPSLABEL = 'allapps',

  MW_APPSETTINGS = 'appsettings',
  MW_APPSETTINGSLABELS = 'appsettings',


  //Be An advisor
  BEANADVISOR_LABEL = 'Be An Advisor',
  AD_SEARCHADVISOR = 'searchadvisor',
  AD_SEARCHADVISOR_LABEL = 'Search advisor',
  BEANADVISOR = 'beanadvisor',
  AD_MYPROFILE_LABEL = 'Profile',
  AD_MYPROFILE = 'myprofile',
  AD_DETAILS_LABEL = 'Advisor Details',
  AD_DETAILS = 'advisordetails',
  AD_PROPOSAL_LABEL = 'Proposals',
  AD_PROPOSAL = 'advisorproposal',
  AD_ACTIVITIES_LABEL = 'Activities',
  AD_ACTIVITIES = 'advisoractivities',
  AD_PAYMENT_LABEL = 'Invoices',
  AD_PAYMENT = 'payment',







  //Documents
  // BDRIVEDOCUMENT = 'documents',
  // BDRIVEDOCUMENT_LABEL = 'Documents',
  BDRIVEENITITES = 'client-work',
  BDRIVEENITITES_LABEL = 'Client Work',

  BDRIVE_CB_ENITITES = 'cb-client-work',
  BDRIVE_CB_ENITITES_LABEL = 'Client Work',

  ENTITYFOLDERS = 'client-work',
  BDRIVE = 'files',
  BDRIVE_LABEL = 'Files',
  BDGROUP = 'groups',
  BDGROUP_LABEL = 'Groups',
  BDRECENT = 'recent',
  BDRECENT_LABEL = 'Recent',
  BDSTARRED = 'starred',
  BDSTARRED_LABEL = 'Starred',
  BDSHARED = 'shared-with-me',
  BDSHARED_LABEL = 'Shared With Me',
  BDSETTINGS = 'appsettings',
  BDSETTINGS_LABEL = 'App Settings',
  BDCLIENTUPLOAD = 'documentsupload/:token?folder=:folder',
  BDCLIENTUPLOAD_LABEL = 'Client Files Upload',

  BDRIVE_INTEGRATION = 'integrations',
  BDRIVE_INTEGRATION_LABEL = 'Integrations',

  BDRIVE_GOOGLE = 'google-drive',
  BDRIVE_GOOGLE_LABEL = 'Google',

  BDRIVE_ACTIVITY_FEED = 'activity-feed',
  BDRIVE_ACTIVITY_FEED_LABEL = 'Activity feed',

  //Organization-Management
  OM_LABEL = 'Organization Management',
  ORGANIZAIONMANAGEMENT = 'organization-management',
  OMFILLING = 'filings',
  OMFILLING_LABEL = 'Filings',
  OMCONTRACTS = 'contracts',
  OMCONTRACTS_LABEL = 'Contracts',
  OMMEMBERS = 'members',
  OMMEMBERS_LABEL = 'Members',
  OMMINUTES = 'minutes',
  OMMINUTES_LABEL = 'Minutes',
  OMHIERARCHY = 'hierarchy',
  OMHIERARCHY_LABEL = 'Hierarchy',
  OMATTRIBUTES = 'attributes',
  OMATTRIBUTES_LABEL = 'Attributes',
  OMGROUPS = 'groups',
  OMGROUPS_LABEL = 'Groups',
  OMALERTS = 'alerts',
  OMALERTS_LABEL = 'Alerts',
  OMREPORTS = 'reports',
  OMREPORTS_LABEL = 'Reports',
  OMMASTERDATA = 'masterdata',
  OMMASTERDATA_LABEL = 'Master data',
  OMSETTINGS = 'settings',
  OMSETTINGS_LABEL = 'Settings',
  OMSETTINGS_SERVICE = 'filings/select-service',
  OMSETTINGS_SERVICE_LABEL = 'Services',
  OM_SERVICE_BANK = 'om-service-bank',
  OM_SERVICE_BANK_LABEL = 'A8 Templates Bank',
  OM_FILLING_TEMPLATES = 'om-fillingtemplates',
  OM_FILLING_TEMPLATES_LABEL = 'Filling templates',

  //Fix cat
  FIXUNCAT = 'fix-uncats',
  FIXUNCAT_LABEL = 'Fix Uncats',
  FU_CLIENTSETTINGS = 'client-settings',
  FU_SETTINGS = 'settings',
  FU_CLIENTSETTINGS_LABEL = 'Client Settings',
  FU_GLOBALSETTINGS = 'global-settings',
  FU_GLOBALSETTINGS_LABEL = 'Global Settings',
  FU_TRANSACTIONS = 'transactions',
  FU_TRANSACTIONS_LABEL = 'Transactions',
  FU_OVERVIEW = 'overview',
  FU_FU_OVERVIEW_LABEL = 'Overview',
  FU_CLIENT_LANDING_URL = 'my-accountant/fix-uncat-transaction',
  FU_CLIENT_LIST_LANDING_URL = 'my-accountant/list',
  MY_ACCOUNTANT_URL = 'my-accountant',
  //vcportal
  VCPORTAL = 'portal',
  VCPORTAL_LABEL = 'Portal',
  VC_MYRELATIONS = 'clients',
  VC_MYRELATIONS_LABEL = 'Clients',
  VC_INVITATIONS = 'vc-invitations',
  VC_INVITATIONS_LABEL = 'Invited Clients',
  VC_TAXFORMS = 'vc-taxforms',
  VC_TAXFORMS_LABEL = 'Tax forms',
  VC_VERIFICATIONS = 'verifications',
  VC_VERIFICATIONS_LABEL = 'Verifications',
  VC_WORKSPACE = 'workspace',
  VC_WORKSPACE_LABEL = 'Workspace',
  VC_PROADVISOR_DATA = "proadvisor-data",
  VC_PROADVISOR_DATA_LABEL = "ProAdvisors data",
  NOTIFICATIONS = "all-notifications",
  NOTIFICATIONS_LABEL = "Notifications",
  VC_ACCOUNTANT = 'accountants',
  VC_ACCOUNTANT_LABEL = 'Accountants',
  //audit
  AUDIT = 'audits',
  AUDIT_LABEL = 'Audits',
  AUDIT_PROPOSALS = 'proposals',
  AUDIT_PROPOSALS_LABEL = 'Proposals',
  AUDIT_SERVICE_BANK = 'service-bank',
  AUDIT_SERVICEBANK_LABEL = 'A8 Templates Bank',
  AUDIT_TEMPLATE_BANK = 'template',
  AUDIT_TEMPLATE_BANK_LABEL = 'Template',
  AUDIT_TEMPLATE = 'audit-template',
  AUDIT_TEMPLATE_LABEL = 'AuditS Template',
  AUDIT_MILESTONES = 'milestones',
  AUDIT_MILESTONES_LABEL = 'Milestones',
  AUDIT_JOBTASK = 'audit-jobtasks',
  AUDIT_JOBTASK_LABEL = 'Audit Job Tasks',
  AUDIT_APPROVALS = 'approvals',
  AUDIT_APPROVALS_LABEL = 'Approvals',
  AUDIT_JOBS = 'audit-jobs',
  AUDIT_JOBS_LABEL = 'Audit Jobs',
  AUDIT_TIMESHEET = 'timesheets',
  AUDIT_TIMESHEET_LABEL = 'Timesheets',
  AUDIT_GROUPS = 'groups',
  AUDIT_GROUPS_LABEL = 'Groups',
  AUDIT_CONTRATS = 'contracts',
  AUDIT_CONTRATS_LABEL = 'Contracts',
  AUDIT_SETUP = 'auditsetup',
  AUDIT_SETUP_LABEL = 'Audit Setup',
  AUDIT_PAYMENTS = 'payments',
  AUDIT_PAYMENTS_LABEL = 'Invoices',
  AUDIT_APPSETTINGD = 'app-settings',
  AUDIT_APPSETTINGD_LABEL = 'App Settings',
  AUDIT_EXPENSES = 'expenses',
  AUDIT_EXPENSES_LABEL = 'Expenses',
  AUDIT_CLIENT_SUBSCRIPTIONS = 'client-subscriptions',
  AUDIT_CLIENT_SUBSCRIPTIONS_LABEL = 'Client subscriptions',
  AUDIT_MASTERDATA = 'master-data',
  AUDIT_MASTERDATA_LABEL = 'Master Data',

  //  LicenseManagementModule
  LIECENSE = 'licensure',
  LM_LABEL = 'Licensure',
  LM_JOBS = 'licensure-jobs',
  LM_JOBS_LABEL = 'Licensure Jobs',
  LM_JOBTASKS = 'licensure-jobtasks',
  LM_JOBTASKS_LABEL = 'Licensure Jobtasks',
  LM_MILESTONES = 'milestones',
  LM_MILESTONES_LABEL = 'Milestones',
  LM_APPROVALS = 'approvals',
  LM_APPROVALS_LABEL = 'Approvals',
  LM_GROUPS = 'groups',
  LM_GROUPS_LABEL = 'Groups',
  LM_TIMESHEETS = 'timesheets',
  LM_TIMESHEETS_LABEL = 'Timesheets',
  LM_EXPENSES = 'expenses',
  LM_EXPENSES_LABEL = 'Expenses',
  LM_CLIENT_SUBSCRIPTIONS = 'client-subscriptions',
  LM_CLIENT_SUBSCRIPTIONS_LABEL = 'Client subscriptions',
  LM_TASK_ISSUES = 'lm-task-issues',
  LM_TASK_ISSUES_LABEL = 'Task Issues',
  LM_TEMPLATE_BANK = 'template-bank',
  LM_TEMPLATE_BANK_LABEL = 'Template Bank',
  LM_PROPOSALS = 'proposals',
  LM_PROPOSALS_LABEL = 'Proposals',
  LM_SERVICE_BANK = 'service-bank',
  LM_SERVICE_BANK_LABEL = 'A8 Templates Bank',
  SEARCH_LIBRARY = 'library',
  SEARCH_LIBRARY_LABEL = 'Search Library',
  LM_MASTER_DATA = 'master-data',
  LM_MASTER_DATA_LABEL = 'Master Data',
  LM_APP_SETTINGS = 'app-settings',
  LM_APP_SETTINGS_LABEL = 'App Settings',
  LM_CONTRACTS = 'contracts',
  LM_CONTRACTS_LABEL = 'Contracts',
  LM_PAYMENTS = 'payments',
  LM_PAYMENTS_LABEL = 'Invoices',
  LM_READISSUE = 'licensure/readissue/:issue_Id',
  LM_READISSUELABEL = 'Issue Link',
  AC_CLIENT_FILES = "client-files",
  AC_CLIENTS_FILES_LABEL = "AC_CLIENTS_FILES_LABEL",
  AC_FILES_ORGANIZE = "AC_FILES_ORGANIZE",
  AC_SUBSCRIPTIONS_ORGANIZE = "AC_SUBSCRIPTIONS_ORGANIZE",
  AC_CLIENT_PROPOSALS = "client-proposals"
}
